import { NgOptimizedImage } from '@angular/common';
import {
    ChangeDetectionStrategy,
    Component,
    computed,
    effect,
    inject,
    input,
    numberAttribute,
    signal
} from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { ENVIRONMENT } from '@sona/angular-util-environment';

export const SUPPORTED_API_SIZES = [16, 32, 64, 128, 180, 192];

@Component({
    selector: 'sona-favicon',
    imports: [NgOptimizedImage, TranslateModule],
    templateUrl: './favicon.component.html',
    styleUrl: './favicon.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class SonaFaviconComponent {
    readonly environment = inject(ENVIRONMENT);

    readonly size = input(24, { transform: numberAttribute });
    readonly fontSize = computed(() => {
        const size = this.size();

        if (size <= 16) {
            return size / 2;
        } else if (size <= 24) {
            return size * 0.625;
        } else if (size <= 32) {
            return size * 0.875;
        }

        return size;
    });
    readonly url = input<string | undefined>();
    protected readonly _faviconLoaded = signal(false);

    protected readonly _faviconSrc = computed(() => {
        const url = this.url();

        if (!url) {
            return '/not-found.svg';
        }

        const size =
            SUPPORTED_API_SIZES.find((s) => s >= this.size()) ??
            SUPPORTED_API_SIZES.at(-1);

        return `${this.environment.faviconUrl}/${new URL(url).hostname}/${size}`;
    });

    constructor() {
        effect(() => {
            this._faviconSrc();
            this._faviconLoaded.set(false);
        });
    }
}
